import { SkuDcReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuDcReportGridData } from '@pages/reporting-pages/deliveries-sku-dc/types/SkuDcReportGridData';
import { valueExist } from '@utils/typescriptGuards';
import { SkuDetailTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSkuReportDetail';



export const convertToGridData = (apiData: SkuDcReport[] | undefined | null): SkuDcReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: SkuDcReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		const totalValue = apiDataItem.transportTypesData[SkuDetailTransportTypes.total];
		const onValue = apiDataItem.transportTypesData[SkuDetailTransportTypes.on];
		const offValue = apiDataItem.transportTypesData[SkuDetailTransportTypes.off];

		gridData.push({
			country: apiDataItem.country,
			executionPlaceName: apiDataItem.executionPlaceName,

			total_volume: totalValue && valueExist(totalValue.volume) ? totalValue.volume : 0,
			total_volumePct: totalValue && valueExist(totalValue.volumePct) ? totalValue.volumePct : 0,
			total_weight: totalValue && valueExist(totalValue.weight) ? totalValue.weight : 0,
			total_ordersCount: totalValue && valueExist(totalValue.ordersCount) ? totalValue.ordersCount : 0,
		
			on_volume: onValue && valueExist(onValue.volume) ? onValue.volume : 0,
			on_volumePct: onValue && valueExist(onValue.volumePct) ? onValue.volumePct : 0,
			on_weight: onValue && valueExist(onValue.weight) ? onValue.weight : 0,
			on_ordersCount: onValue && valueExist(onValue.ordersCount) ? onValue.ordersCount : 0,
		
			off_volume: offValue && valueExist(offValue.volume) ? offValue.volume : 0,
			off_volumePct: offValue && valueExist(offValue.volumePct) ? offValue.volumePct : 0,
			off_weight: offValue && valueExist(offValue.weight) ? offValue.weight : 0,
			off_ordersCount: offValue && valueExist(offValue.ordersCount) ? offValue.ordersCount : 0,
		});
	}

	return gridData;
}